import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import { useMemo } from 'react';

export default function Coin({ placeholder, vaults = [], onChange }) {
  const currencies = useMemo(() => {
    const visited = new Set();
    const list = [];
    for (const vault of vaults) {
      const { currency_id } = vault;

      if (!currency_id || visited.has(currency_id)) continue;

      visited.add(currency_id);
      list.push(vault?.currency);
    }
    return list;
  }, [vaults]);

  if (!currencies.length) return <></>;

  const defaultCrypto = currencies[0];

  return (
    <div className='flex flex-col gap-2'>
      <Select defaultValue={defaultCrypto.currency_id} onValueChange={onChange}>
        <SelectTrigger className='py-6' aria-label={placeholder}>
          <SelectValue placeholder={placeholder} />
        </SelectTrigger>
        <SelectContent className='[&_*[role=option]>span]:end-2 [&_*[role=option]>span]:start-auto [&_*[role=option]]:pe-8 [&_*[role=option]]:ps-2'>
          {currencies.map((crypto, index) => (
            <SelectItem key={index} value={crypto.currency_id}>
              {crypto.name}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
}
